import axios from 'axios';
import { config } from '@/helpers/variables';
import { API_URL } from '@/helpers/variables';

export const collectionService = {
  async postLike(id: number) {
    const API_POST_URL = `${API_URL}satellite/collections/votes/${id}`;
    config;
    axios
      .post(API_POST_URL, config)
      .then((res) => {})
      .catch((err) => {
        console.log('ERROR: ====', err);
      });
  },
};
